export const onlySpaces = (str: string): boolean =>
  str === "" ? false : str.trim().length === 0;
